import { render, staticRenderFns } from "./FrmPoI.vue?vue&type=template&id=7938e525&scoped=true"
import script from "./FrmPoI.vue?vue&type=script&lang=js"
export * from "./FrmPoI.vue?vue&type=script&lang=js"
import style0 from "./FrmPoI.vue?vue&type=style&index=0&id=7938e525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7938e525",
  null
  
)

export default component.exports